<template>
  <div class="col-sm-12 list-container">
    <div
      id="price-list-add-button"
      class="data-list-item add my-1"
      @click.stop="$emit('add')"
    >
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="calendar-check"
          class="card-body-icon"
        />
      </div>
    </div>

      <div v-if="results.length > 0" class="col-sm-12 list-content result-table my-2">
          <vue3-datatable
              :rows="results"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="emitEdit"
          >
          <template #active="row">
              {{ row.value.active ? $t('common.yes') :  $t('common.no')}}
          </template>
          </vue3-datatable>
      </div>
  </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
export default {
    name: 'PriceListList',
    components: {Vue3Datatable},
    data() {
        return {
            fields: [
                    {field: 'id', title: this.$t('common.id'), sort: true,  headerClass: 'routa-table-header', type: 'number'},
                    {field: 'name', title: this.$t('common.name'), sort: true,  headerClass: 'routa-table-header'},
                    {field: 'active', title: this.$t('pricelist.active'), sort: true,  headerClass: 'routa-table-header'},
            ]
        }
    },
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            },
        }
    },
    emits: ['add', 'edit'],
    methods: {
        emitEdit(item) {
            this.$emit('edit', item)
        }
    }
}
</script>
